import ChevronRight from '@mui/icons-material/ChevronRight';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import IconPremium from 'components/icon/assets/ico-premium-integration.svg';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { FeatureFlags } from 'utils/featureFlags';

interface AutomaticReminderSectionProps {
  onNext: VoidFunction;
}

export const AutomaticReminderSection: React.FC<AutomaticReminderSectionProps> = ({ onNext }) => {
  const { [FeatureFlags.autoReminders]: isAutoRemindersEnabled } = useFeatureFlag([FeatureFlags.autoReminders]);

  const { t } = useTranslation();

  if (!isAutoRemindersEnabled) {
    return null;
  }

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center" onClick={onNext} sx={{ cursor: 'pointer' }}>
        <Stack>
          <Typography variant="h5" fontSize="16px" fontWeight={400}>
            {t('share_document_v3.automatic_reminders.title')} <img src={IconPremium} alt="premium" />
          </Typography>
          <Typography variant="body1" fontSize="16px" fontWeight={400} color="text.secondary">
            {t('share_document_v3.automatic_reminders.text')}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="flex-end">
          <IconButton data-testid="share-card-v3-share-settings-button">
            <ChevronRight />
          </IconButton>
        </Stack>
      </Stack>
      <Divider />
    </>
  );
};
